"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsableSectionHeader = exports.SectionBar = exports.SectionContent = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Common_1 = require("../Common");
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var borderRadius_1 = require("../../utils/styled/borderRadius");
exports.SectionContent = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.SectionContent.displayName = 'SectionContent';
var ButtonToggle = (0, styled_components_1.default)(Common_1.Button).attrs(function () { return ({
    floating: true,
    color: 'secondary',
    size: 'sm',
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\tright: 25px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n"], ["\n\tposition: absolute;\n\tright: 25px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n"])));
exports.SectionBar = styled_components_1.default.div.attrs(function () { return ({
    className: 'tws-section-header',
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: ", ";\n\tmin-height: 50px;\n\tposition: relative;\n\tbackground: ", ";\n\tpadding: 16px 25px 16px ", ";\n\tcolor: ", ";\n\tfont-weight: ", ";\n\tfont-size: 14px;\n\tline-height: 16px;\n\tmargin-bottom: ", "px;\n\t", "\n\t&::before {\n\t\tcontent: '';\n\t\twidth: 10px;\n\t\theight: ", ";\n\t\tposition: absolute;\n\t\ttop: ", ";\n\t\tleft: ", ";\n\t\tbackground-color: ", ";\n\t\tdisplay: block;\n\t\tborder-radius: ", " ", " ", " ", ";\n\t}\n"], ["\n\twidth: ", ";\n\tmin-height: 50px;\n\tposition: relative;\n\tbackground: ", ";\n\tpadding: 16px 25px 16px ", ";\n\tcolor: ", ";\n\tfont-weight: ", ";\n\tfont-size: 14px;\n\tline-height: 16px;\n\tmargin-bottom: ", "px;\n\t", "\n\t&::before {\n\t\tcontent: '';\n\t\twidth: 10px;\n\t\theight: ", ";\n\t\tposition: absolute;\n\t\ttop: ", ";\n\t\tleft: ", ";\n\t\tbackground-color: ", ";\n\t\tdisplay: block;\n\t\tborder-radius: ", " ", " ", " ", ";\n\t}\n"])), globalVars_module_scss_1.default.fullWidth, globalVars_module_scss_1.default.mainGray, globalVars_module_scss_1.default.spacing30, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.fontWeightBold, function (props) { return (props.isCollapsed ? '40' : '0'); }, (0, borderRadius_1.borderTopRadius)(globalVars_module_scss_1.default.borderRadius4), globalVars_module_scss_1.default.fullHeight, globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.tertiaryBlue2, globalVars_module_scss_1.default.borderRadius4, globalVars_module_scss_1.default.borderRadius0, globalVars_module_scss_1.default.borderRadius0, globalVars_module_scss_1.default.borderRadius0);
exports.SectionBar.displayName = 'SectionBar';
var CollapsableSectionHeader = /** @class */ (function (_super) {
    __extends(CollapsableSectionHeader, _super);
    function CollapsableSectionHeader(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.state = { isCollapsed: (_a = _this.props.defaultCollapsed) !== null && _a !== void 0 ? _a : false };
        _this.handleToggleCollapse = _this.handleToggleCollapse.bind(_this);
        return _this;
    }
    CollapsableSectionHeader.prototype.render = function () {
        var _a = this.props, className = _a.className, headerContent = _a.headerContent;
        return (React.createElement(React.Fragment, null,
            React.createElement(exports.SectionBar, { className: className, isCollapsed: this.state.isCollapsed, "aria-expanded": !this.state.isCollapsed },
                React.createElement(exports.SectionContent, null,
                    headerContent,
                    React.createElement(ButtonToggle, { "aria-expanded": !this.state.isCollapsed, onClick: this.handleToggleCollapse },
                        React.createElement(Common_1.Icon, { name: "angle-".concat(this.state.isCollapsed ? 'down' : 'up') })))),
            !this.state.isCollapsed && this.props.children));
    };
    CollapsableSectionHeader.prototype.handleToggleCollapse = function () {
        this.setState({ isCollapsed: !this.state.isCollapsed });
    };
    return CollapsableSectionHeader;
}(React.Component));
exports.CollapsableSectionHeader = CollapsableSectionHeader;
var templateObject_1, templateObject_2, templateObject_3;
